import { jsx as _jsx } from "react/jsx-runtime";
const SupportFormNestedFieldsContainer = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        style: {
            paddingLeft: 15,
            borderLeft: "1px solid #f0f3f7"
        },
        children: children
    });
};
export { SupportFormNestedFieldsContainer };
